<script setup lang="ts">
import BaseInput from "@/core/components/base/BaseInput.vue";

const emits = defineEmits<{
    (e: 'update:modelValue', payload: number): void
}>();

defineProps<{
    modelValue: number;
}>();
</script>

<template>
  <BaseInput
    :value="modelValue" type="number" label="Nombre de points"
    @input="emits('update:modelValue', Number($event) || 0)"
  />
</template>
